module.exports = __webpack_public_path__ + "img/IMG-20200817-WA0012.335aa8d8.jpg";